import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Table } from "react-bootstrap";
// import SearchFilter from "../common/searchFilter";
import { CheckOutlined } from "@ant-design/icons";
import isNull from "lodash/isNull";
import { FaFilter } from "react-icons/fa";

function TableComponent(props) {
  const {
    tableColumnTitles,
    tabRequests,
    tableRowRequests,
    updateResponseData,
  } = props;
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 10;
  const endOffset = itemOffset + itemsPerPage;
  let pageCount = Math.ceil(tabRequests?.length / itemsPerPage);
  const test = tabRequests?.slice(itemOffset, endOffset);
  const [showingData, setShowingData] = useState([]);
  const [isShowFilter, setIsShowFilter] = useState(false);
  const [isShowSort] = useState(false);

  const [filterChecked, setFilterChecked] = React.useState(
    new Array(tableColumnTitles?.length).fill(false)
  );
  const [search, setSearch] = React.useState(
    new Array(tableColumnTitles?.length).fill({
      searchField: "",
      searchValue: "",
    })
  );
  const [sortIndex] = React.useState(null);

  // showingData = tabRequests?.slice(itemOffset, endOffset);
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % tabRequests?.length;
    setItemOffset(newOffset);
  };

  const handleOnChange = (index, e, fieldName) => {
    const searchValue = e.target.value;
    const searchState = search.map((ele, i) =>
      i === index ? { ...ele, searchField: fieldName, searchValue } : ele
    );
    setSearch(searchState);
    updateResponseData(searchState);
  };

  const getHistoryWithSortFilter = async () => {};

  const handleSearch = async (index, e) => {
    if (e.key === "Enter" && e.target.value.trim()) {
      await getHistoryWithSortFilter(1);
    } else {
      await getHistoryWithSortFilter(1);
    }
  };

  useEffect(() => {
    async function getAllAPI() {
      setShowingData(test);
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemOffset]);

  useEffect(() => {
    async function getAllAPI() {
      setShowingData(test);
      setItemOffset(0);
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabRequests]);

  const checkedChange = (position) => {
    filterChecked.map(async (item, index) => {
      // eslint-disable-next-line no-nested-ternary
      if (index === position && item && search[position].searchValue) {
      }
    });
    const updatedCheckedState = filterChecked.map((item, index) =>
      // eslint-disable-next-line no-nested-ternary
      index === position ? !item : item ? !item : item
    );
    setFilterChecked(updatedCheckedState);

    // set other search state value blank
    const searchState = search.map((ele) => {
      return { ...ele, searchField: "", searchValue: "" };
    });
    setSearch(searchState);
  };

  const filterContent = (index, fieldName) => {
    return (
      <>
        {filterChecked[index] && (
          <div className="filter-here-add-all-only-cls">
            <div className="searching-input-cls-add">
              <input
                type="text"
                placeholder="Search"
                value={search[index].searchValue}
                onChange={(e) => handleOnChange(index, e, fieldName)}
                onKeyDown={(e) => handleSearch(index, e)}
              />
              <img
                src="images/icon-search.png"
                alt=""
                onClick={(e) => handleSearch(index, e)}
              />
            </div>
          </div>
        )}
        <div className="input-typing-add ms-2">
          {filterChecked[index] ? (
            <div onClick={() => checkedChange(index)}>
              <CheckOutlined color="#FFFFFF" />
            </div>
          ) : (
            <input
              type="checkbox"
              className="checking-input-all-cls-here"
              checked={filterChecked[index]}
              onChange={() => checkedChange(index)}
            />
          )}
        </div>
      </>
    );
  };

  const onFilterButtonHandler = (event) => {
    if (isShowFilter) {
      // check if atleast one filter is applied or not
      const updatedCheckedState = filterChecked.map((item) =>
        item ? !item : item
      );
      setFilterChecked(updatedCheckedState);

      // set all search state value blank
      const searchState = search.map((ele) => ({
        ...ele,
        searchField: "",
        searchValue: "",
      }));
      setSearch(searchState);
      // check already sort applied or not
      if (isShowSort && !isNull(sortIndex)) {
      }
    }
    setIsShowFilter(!isShowFilter);
  };

  const refreshPageHandler = () => {
    if (isShowFilter) {
      const updatedCheckedState = filterChecked.map((item) =>
        item ? !item : item
      );
      setFilterChecked(updatedCheckedState);

      const searchState = search.map((ele) => ({
        ...ele,
        searchField: "",
        searchValue: "",
      }));
      setSearch(searchState);
    }

    // Refresh the page
    // eslint-disable-next-line no-restricted-globals
    location.reload();
    // location.reload();
  };

  return (
    <>
      <div className="validation-container">
        <div className="iconmain-div d-flex align-items-center">
          <div
            className="icon-container filter-cls-add-here-move-left-side refresh-btn-cls-adding-prs"
            onClick={onFilterButtonHandler}
          >
            Filter
            <span className="refresh-cls-all-iop">
              <FaFilter className="icon-button" />
            </span>
          </div>
          <div className="refresh-btn-cls-adding-used">
            <button
              type="button"
              className="btn btn-primary refresh-btn-cls-adding-prs"
              onClick={refreshPageHandler}
            >
              Refresh
              <span className="refresh-cls-all-iop">
                <svg
                  width="26px"
                  height="26px"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9381 13C19.979 12.6724 20 12.3387 20 12C20 7.58172 16.4183 4 12 4C9.49942 4 7.26681 5.14727 5.7998 6.94416M4.06189 11C4.02104 11.3276 4 11.6613 4 12C4 16.4183 7.58172 20 12 20C14.3894 20 16.5341 18.9525 18 17.2916M15 17H18V17.2916M5.7998 4V6.94416M5.7998 6.94416V6.99993L8.7998 7M18 20V17.2916"
                    stroke="#fd0b93"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className="table-responsive adding-only-radius">
        <div className="w-100 all-same-table-component-cls">
          <Table className="only-this-table-cls position-relative" hover>
            <thead>
              <tr>
                {tableColumnTitles &&
                  tableColumnTitles?.map((title, index) => (
                    <th key={index}>
                      <div className="d-flex align-items-center automatic-add-align">
                        <label className="title-labeling">{title.name}</label>
                        {title.isSortFilter && (
                          <div className="d-flex align-items-center">
                            {/* {isShowSort && sortContent(index, title.field)} */}
                            {isShowFilter && filterContent(index, title.field)}
                          </div>
                        )}
                      </div>
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {showingData?.length > 0 ? (
                showingData.map((req, index) => (
                  <React.Fragment key={req?.id || index}>
                    {tableRowRequests(req, index)}
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={tableColumnTitles.length}
                    style={{ textAlign: "center" }}
                  >
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      <div className="d-flex align-items-center mt-4">
        {pageCount > 1 && (
          <div className="exportdiv ms-auto">
            <ReactPaginate
              previousLabel="Prev"
              nextLabel="Next"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              pageCount={pageCount}
              pageRangeDisplayed={2}
              marginPagesDisplayed={1}
              onPageChange={handlePageClick}
              containerClassName="pagination justify-content-center"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              activeClassName="active"
            />
          </div>
        )}
      </div>
    </>
  );
}

export default TableComponent;
